import { useMemo } from 'react';

import { unparse } from 'papaparse';

export const useCsvData = (
  rowValues: { [key: string]: string | number }[],
  fields: string[],
  config?: Papa.UnparseConfig,
): string => {
  return useMemo(() => {
    const data = rowValues.map((obj) => Object.values(obj));
    return unparse({ data, fields }, config);
  }, [rowValues, config, fields]);
};
